// extracted by mini-css-extract-plugin
module.exports = {"calculator":"styles_calculator__R_fT5","calculatorLoader":"styles_calculatorLoader__6amZE"};